<mat-card class="rounded-lg border border-slate-200 p-6 shadow-sm">
  <mat-card-header class="mb-6">
    <mat-card-title class="text-2xl font-semibold text-(--pg-brand-blue)">{{ title() }}</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <form [formGroup]="affiliateForm" (ngSubmit)="submit()">
      <mat-stepper [linear]="!readOnly()" #stepper>
        <mat-step [stepControl]="personalDetailsForm" label="Personal details">
          <div class="grid gap-4 pt-4 md:grid-cols-2" [formGroup]="personalDetailsForm">
            <mat-form-field appearance="outline" class="w-full md:col-span-1">
              <mat-label>Name *</mat-label>
              <input matInput formControlName="name" [readonly]="readOnly()" />
              @if (personalDetailsForm.controls.name.invalid && personalDetailsForm.controls.name.touched) {
                <mat-error>Name is required.</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full md:col-span-1">
              <mat-label>Surname *</mat-label>
              <input matInput formControlName="surname" [readonly]="readOnly()" />
              @if (personalDetailsForm.controls.surname.invalid && personalDetailsForm.controls.surname.touched) {
                <mat-error>Surname is required.</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full md:col-span-1">
              <mat-label>Age</mat-label>
              <input matInput formControlName="age" type="number" [readonly]="readOnly()" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full md:col-span-1">
              <mat-label>Gender</mat-label>
              <mat-select formControlName="genderId">
                <mat-option value="">Select gender</mat-option>
                @for (item of genders(); track item.id) {
                  <mat-option [value]="item.id">{{ item.name ?? item.code }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full md:col-span-1">
              <mat-label>Language</mat-label>
              <mat-select formControlName="languageId">
                <mat-option value="">Select language</mat-option>
                @for (item of languages(); track item.id) {
                  <mat-option [value]="item.id">{{ item.name ?? item.code }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full md:col-span-1">
              <mat-label>Religion</mat-label>
              <mat-select formControlName="religionId">
                <mat-option value="">Select religion</mat-option>
                @for (item of religions(); track item.id) {
                  <mat-option [value]="item.id">{{ item.name ?? item.code }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="flex justify-end pt-4">
            <!-- <button mat-raised-button color="primary" type="button" matStepperNext>Next</button>   -->
            <button matButton="filled" type="button" (click)="utils.stepForward(stepper)">
              <mat-icon>arrow_forward</mat-icon>
              Next
            </button>
          </div>
        </mat-step>

        <mat-step [stepControl]="contactDetailsForm" label="Contact details">
          <div class="grid gap-4 pt-4 md:grid-cols-2" [formGroup]="contactDetailsForm">
            <mat-form-field appearance="outline" class="w-full md:col-span-2">
              <mat-label>Address</mat-label>
              <textarea matInput formControlName="address" rows="3" [readonly]="readOnly()"></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full md:col-span-1">
              <mat-label>Email address</mat-label>
              <input matInput formControlName="emailAddress" type="email" [readonly]="readOnly()" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full md:col-span-1">
              <mat-label>Contact number</mat-label>
              <input matInput formControlName="contactNumber" [readonly]="readOnly()" />
            </mat-form-field>
          </div>

          <div class="flex justify-between pt-4">
            <!-- <button mat-button type="button" matStepperPrevious>Back</button>
            <button mat-raised-button color="primary" type="button" matStepperNext>Next</button> -->
            <button matButton="filled" type="button" (click)="utils.stepBack(stepper)">
              <mat-icon>arrow_back</mat-icon>
              Back
            </button>
            <button matButton="filled" type="button" (click)="utils.stepForward(stepper)">
              <mat-icon>arrow_forward</mat-icon>
              Next
            </button>
          </div>
        </mat-step>

        <mat-step [stepControl]="professionalDetailsForm" label="Professional details">
          <div class="grid gap-4 pt-4 md:grid-cols-2" [formGroup]="professionalDetailsForm">
            <mat-form-field appearance="outline" class="w-full md:col-span-1">
              <mat-label>Affiliate discipline</mat-label>
              <mat-select formControlName="affiliateDisciplineId">
                <mat-option value="">Select discipline</mat-option>
                @for (item of affiliateDisciplines(); track item.id) {
                  <mat-option [value]="item.id">{{ item.name ?? item.code }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full md:col-span-1">
              <mat-label>Experience (years)</mat-label>
              <input matInput formControlName="experience" type="number" [readonly]="readOnly()" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full md:col-span-1">
              <mat-label>Regulatory registration number</mat-label>
              <input matInput formControlName="regulatoryRegistrationNumber" [readonly]="readOnly()" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full md:col-span-1">
              <mat-label>BHF registration</mat-label>
              <input matInput formControlName="bhfRegistration" [readonly]="readOnly()" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full md:col-span-1">
              <mat-label>Company name</mat-label>
              <input matInput formControlName="companyName" [readonly]="readOnly()" />
            </mat-form-field>

            <mat-checkbox class="w-full md:col-span-1" formControlName="trainedByAffiliate">
              Trained by affiliate
            </mat-checkbox>

            <mat-form-field appearance="outline" class="w-full md:col-span-2">
              <mat-label>Service types</mat-label>
              <mat-select formControlName="interventionTypeIds" multiple>
                @for (item of interventionStore.interventionTypes(); track item.id) {
                  <mat-option [value]="item.id">{{ item.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-checkbox class="w-full md:col-span-1" formControlName="isAvailableForReferrals">
              Available for referrals
            </mat-checkbox>

            <mat-form-field appearance="outline" class="w-full md:col-span-1">
              <mat-label>Max active caseload</mat-label>
              <input matInput formControlName="maxActiveCaseload" type="number" min="0" [readonly]="readOnly()" />
              @if (professionalDetailsForm.controls.maxActiveCaseload.hasError('min') && professionalDetailsForm.controls.maxActiveCaseload.touched) {
                <mat-error>Max active caseload must be 0 or more.</mat-error>
              }
              @if (initialValue(); as affiliate) {
                <mat-hint>Currently {{ affiliate.currentActiveCaseload }} active</mat-hint>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full md:col-span-2">
              <mat-label>Therapy modalities</mat-label>
              <textarea matInput formControlName="therapyModalities" rows="2" [readonly]="readOnly()"></textarea>
            </mat-form-field>
          </div>

          <div class="flex justify-between pt-4">
            <!-- <button mat-button type="button" matStepperPrevious>Back</button>
            <button mat-raised-button color="primary" type="button" matStepperNext>Next</button> -->
            <button matButton="filled" type="button" (click)="utils.stepBack(stepper)">
              <mat-icon>arrow_back</mat-icon>
              Back
            </button>
            <button matButton="filled" type="button" (click)="utils.stepForward(stepper)">
              <mat-icon>arrow_forward</mat-icon>
              Next
            </button>
          </div>
        </mat-step>

        <mat-step [stepControl]="accessibilityForm" label="Accessibility">
          <div class="grid gap-4 pt-4 md:grid-cols-2" [formGroup]="accessibilityForm">
            <mat-checkbox class="md:col-span-1" formControlName="wheelchairFriendly">
              Wheelchair friendly
            </mat-checkbox>

            <mat-checkbox class="md:col-span-1" formControlName="signLanguageFriendly">
              Sign language friendly
            </mat-checkbox>
          </div>

          <section class="mb-5 mt-6 rounded-2xl border border-slate-200 p-4">
            <div class="mb-3 flex items-center justify-between gap-3 border-b border-slate-100 pb-2">
              <h3 class="font-medium text-slate-800">Suburbs</h3>
              @if (!readOnly()) {
                <button
                  mat-icon-button
                  type="button"
                  (click)="addSuburb()"
                  aria-label="Add suburb"
                  matTooltip="Add suburb">
                  <mat-icon>add</mat-icon>
                </button>
              }
            </div>
            @if (suburbsForm.length === 0) {
              <p class="text-sm text-slate-500">No suburbs added yet.</p>
            }
            <div formArrayName="suburbs" class="grid gap-2">
              @for (row of suburbsForm.controls; track row; let index = $index) {
                <div
                  [formGroupName]="index"
                  class="grid items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 p-3 md:grid-cols-[1fr_1fr_1fr_auto]">
                  <mat-form-field appearance="outline">
                    <mat-label>Suburb *</mat-label>
                    <input matInput formControlName="suburb" [readonly]="readOnly()" />
                    @if (row.get('suburb')?.invalid && row.get('suburb')?.touched) {
                      <mat-error>Suburb is required.</mat-error>
                    }
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>Province</mat-label>
                    <mat-select formControlName="provinceId" color="primary">
                      <mat-option value="">Select province</mat-option>
                      @for (item of provinces(); track item.id) {
                        <mat-option [value]="item.id">{{ item.name ?? item.code }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>Travel radius (km)</mat-label>
                    <input matInput formControlName="travelRadiusKm" type="number" min="0" [readonly]="readOnly()" />
                    @if (row.get('travelRadiusKm')?.hasError('min') && row.get('travelRadiusKm')?.touched) {
                      <mat-error>Travel radius must be 0 or more.</mat-error>
                    }
                  </mat-form-field>

                  <div class="flex items-center gap-2">
                    <mat-checkbox formControlName="isPrimary">Primary</mat-checkbox>
                    @if (!readOnly()) {
                      <button
                        mat-icon-button
                        type="button"
                        (click)="removeSuburb(index)"
                        aria-label="Remove suburb"
                        matTooltip="Remove">
                        <mat-icon>delete</mat-icon>
                      </button>
                    }
                  </div>
                </div>
              }
            </div>
          </section>

          <div class="flex justify-between pt-4">
            <button mat-button type="button" matStepperPrevious>Back</button>
            @if (!readOnly()) {
              <!-- <button mat-raised-button color="primary" type="submit" [disabled]="affiliateForm.invalid || busy()">
                @if (busy()) {
                  <mat-spinner diameter="20" class="mr-2" />
                }
                {{ submitLabel() }}
              </button> -->
              <button matButton="filled" type="submit">
                <mat-icon>upload</mat-icon>
                {{ submitLabel() }}
              </button>
            }
          </div>
        </mat-step>
      </mat-stepper>
    </form>
  </mat-card-content>
</mat-card>
